import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpResponse, HttpEvent, HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';
import { AuthService } from '../../../../@core/auth/auth.service';
import { FieldEventDTO, FieldEventReportTemplate, ScoutingReportEmailDTO } from '../models/field-event';
import { FieldEventGpsPointDTO } from '../models/field-event-gps-point';

@Injectable({
    providedIn: 'root'
})
export class FieldEventsService {

    protected basePath = '/';

    constructor(
        protected httpClient: HttpClient,
        private authService: AuthService
    ) {
        this.basePath = environment.PLATFORM_API_URL;
    }

    public deleteFieldEvent(id: number): Observable<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling apiFieldEventsByIdDelete.');
        }

        return this.httpClient.delete(`${this.basePath}/api/FieldEvents/${encodeURIComponent(String(id))}`);
    }

    /**
     * 
     * 
     * @param id 
     * @param authorization Please insert JWT with Bearer into field
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getFieldEventbyId(id: number): Observable<FieldEventDTO> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling apiFieldEventsByIdGet.');
        }

        return this.httpClient.get<FieldEventDTO>(`${this.basePath}/api/FieldEvents/${encodeURIComponent(String(id))}`);
    }

    /**
     * 
     * 
     * @param id 
     * @param authorization Please insert JWT with Bearer into field
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public putFieldEvent(id: number, data: FieldEventDTO): Observable<void> {
        if (id === null || id === undefined) {
            throw new Error('id is required');
        }
        const fieldEvent: FieldEventDTO = {
            ...data,
            images: undefined
        };


        return this.httpClient.put<void>(
            `${this.basePath}/api/FieldEvents/${encodeURIComponent(String(id))}`,
            fieldEvent
        );
    }
    /**
     * 
     * 
     * @param authorization Please insert JWT with Bearer into field
     * @param blockId 
     * @param varietyId 
     * @param farmId 
     * @param cropYear 
     * @param fieldEventTypeId 
     */
    public getFieldEvents(blockId?: number, varietyId?: number, farmId?: number, cropYear?: number, fieldEventTypeId?: number, limit?: number, includeThumbnails?: boolean): Observable<FieldEventDTO[]> {
        let queryParameters = new HttpParams();

        if (blockId !== undefined && blockId !== null) {
            queryParameters = queryParameters.set('blockId', <any>blockId);
        }
        if (varietyId !== undefined && varietyId !== null) {
            queryParameters = queryParameters.set('varietyId', <any>varietyId);
        }
        if (farmId !== undefined && farmId !== null) {
            queryParameters = queryParameters.set('farmId', <any>farmId);
        }
        if (cropYear !== undefined && cropYear !== null) {
            queryParameters = queryParameters.set('cropYear', <any>cropYear);
        }
        if (fieldEventTypeId !== undefined && fieldEventTypeId !== null) {
            queryParameters = queryParameters.set('fieldEventTypeId', <any>fieldEventTypeId);
        }

        if (limit) {
            queryParameters = queryParameters.set('limit', <any>limit);
        }

        // includeThumbnails: additive param — wires up the Hub's existing includeThumbnails
        // support (FieldEventsController already accepts it) which this wrapper previously
        // never exposed. Backward compatible: existing callers omit it and behavior is unchanged.
        if (includeThumbnails !== undefined && includeThumbnails !== null) {
            queryParameters = queryParameters.set('includeThumbnails', <any>includeThumbnails);
        }

        return this.httpClient.get<FieldEventDTO[]>(`${this.basePath}/api/FieldEvents`,
            {
                params: queryParameters
            }
        );
    }

    /**
     * 
     * 
     * @param authorization Please insert JWT with Bearer into field
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public postFieldEvent(body?: FieldEventDTO): Observable<any> {
        return this.httpClient.post<FieldEventDTO>(`${this.basePath}/api/FieldEvents`, body);
    }

    public postEventNotification(file: File[], fieldEventId): Observable<FormData> {
        let formData = new FormData();

        formData.append('fieldEventId', fieldEventId);

        for (const image of file) {
            formData.append('file', image);
        }

        return this.httpClient.post<any>(`${this.basePath}/api/FieldEvents/Notification`, formData);
    }
    public apiBlocksCreateUpdateGpsPointsPut(body?: Array<FieldEventGpsPointDTO>): Observable<FieldEventGpsPointDTO> {
        return this.httpClient.put(`${this.basePath}/api/FieldEvents/CreateUpdateGpsPoints`, body);
    }

    public getFieldEventbyIdv2(id: number): Observable<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling apiFieldEventsByIdGet.');
        }

        return this.httpClient.get<any>(`${this.basePath}/api/FieldEvents/${encodeURIComponent(String(id))}/v2`);
    }
    public SendNotificationManually(body: FieldEventReportTemplate): Observable<any> {
        return this.httpClient.post<FieldEventReportTemplate>(`${this.basePath}/api/FieldEvents/SendNotificationManually`, body);
    }

    public sendScoutingReportEmail(data: ScoutingReportEmailDTO): Observable<any> {
        return this.httpClient.post(
            `${this.basePath}/api/SprayPurchaseOrder/email`,
            data,
            { responseType: 'text' }
        );
    }

}
